import { TFooterInfo, TPayloadUpdateSuccess } from '@/services';
import { mergeListItemUpdated } from '@/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { formatFooterInfoList, RootState } from '..';
import {
	IFooterInfoDetailStore,
	IPayloadGetFooterInfoListRequest,
	IPayloadGetFooterInfoListSuccess,
	TCreateFooterInfoRequest,
	TPayloadDeleteFooterInfoRequest,
} from './footer-info.type';

const initialState = {
	fetching: false,
	footerInfoList: [] as IFooterInfoDetailStore[],
	total: 0,
	params: {},
};

const footerInfoSlice = createSlice({
	initialState,
	name: 'footerInfo',
	reducers: {
		/**---- GET FOOTER_INFO LIST START ---- */
		getFooterInfoListRequest: (
			state,
			action: PayloadAction<IPayloadGetFooterInfoListRequest>
		) => {
			state.fetching = true;
		},
		getFooterInfoListSuccess: (
			state,
			action: PayloadAction<IPayloadGetFooterInfoListSuccess>
		) => {
			const { footerInfoList } = action.payload;
			state.fetching = false;
			state.footerInfoList = footerInfoList;
			state.total = footerInfoList?.length;
		},
		getFooterInfoListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET FOOTER_INFO LIST END ---- */
		/**---- CREATE FOOTER_INFO START ---- */

		createFooterInfoRequest: (
			state,
			action: PayloadAction<TCreateFooterInfoRequest>
		) => {
			state.fetching = true;
		},
		createFooterInfoSuccess: (state) => {
			state.fetching = false;
		},
		createFooterInfoFailure: (state) => {
			state.fetching = false;
		},
		/**---- CREATE FOOTER_INFO END ---- */

		/**---- DELETE FOOTER_INFO START ---- */

		deleteFooterInfoRequest: (
			state,
			action: PayloadAction<TPayloadDeleteFooterInfoRequest>
		) => {
			state.fetching = true;
		},

		deleteFooterInfoSuccess: (state) => {
			state.fetching = false;
		},

		deleteFooterInfoFailure: (state) => {
			state.fetching = false;
		},
		/**---- DELETE FOOTER_INFO END ---- */

		/** UPDATE FOOTER_INFO LIST START */
		updateFooterInfoListSuccess: (
			state,
			action: PayloadAction<TPayloadUpdateSuccess<TFooterInfo>>
		) => {
			const { data } = action.payload;
			const footerInfoList = [...state.footerInfoList];
			state.footerInfoList = formatFooterInfoList(
				mergeListItemUpdated<IFooterInfoDetailStore, TFooterInfo>(
					footerInfoList,
					data
				)
			);
		},
		/** UPDATE FOOTER_INFO LIST END */
	},
});

export const FooterInfoSelectors = {
	selectFetching: (state: RootState) => state.footerInfo.fetching,
	selectFooterInfoList: (state: RootState) => state.footerInfo.footerInfoList,
	selectTotal: (state: RootState) => state.footerInfo.total,
	selectParams: (state: RootState) => state.footerInfo.params,
};

export const FooterInfoActions = footerInfoSlice.actions;
export const FooterInfoReducer = footerInfoSlice.reducer;
